const casesContainer = document.querySelector('.Cases.Overview.slider');

if (casesContainer) {
    const items = casesContainer.querySelectorAll('.block-grid > li');
    items.forEach(item => {
        item.addEventListener('click', () => {
            items.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
        });
    });
}